export default Validator => {
  Validator.register(
    'youtube',
    function(value) {
      return new RegExp(
        /(?:https?:\/\/)?(?:www\.)?youtu\.?be(?:\.com)?\/?.*(?:watch|embed|)(?:.*v=|v\/|\/)([\w\-_]+)\&?/,
      ).test(value)
    },
    ':attribute er ikke gyldig',
  )
}
